import { render, staticRenderFns } from "./CurrentTimeClock.vue?vue&type=template&id=649972b9&scoped=true&"
import script from "./CurrentTimeClock.vue?vue&type=script&lang=js&"
export * from "./CurrentTimeClock.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTimeClock.vue?vue&type=style&index=0&id=649972b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649972b9",
  null
  
)

export default component.exports